import React, { useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ContentModal from "components/ContentModal";
import { ACTIONS } from "./Constants";

const RetirePolicyDialog = ({
  open,
  selectedHealthPlan,
  handleClose,
  handleConfirm,
}) => {
  const [cabQuarter, setCabQuarter] = useState("");
  const [cabYear, setCabYear] = useState("");
  const [effectiveDate, setEffectiveDate] = useState(dayjs()); // Use dayjs for date handling

  const handleDateChange = (newDate) => {
    setEffectiveDate(newDate);
  };

  const handleRetirePolicyConfirm = () => {
    // Pass selected values to the parent component
    handleConfirm({
      action: ACTIONS.RETIRE_POLICY,
      cabQuarter,
      cabYear,
      effectiveDate: effectiveDate,
    });
  };

  const isConfirmDisabled = !cabQuarter || !cabYear || !effectiveDate;

  return (
    <ContentModal
      open={open}
      handleClose={handleClose}
      title={
        <Box
          sx={{
            display: "flex",
            fontWeight: "bold",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span>{`Retire Policy Data`}</span>
        </Box>
      }
      content={
        <Box>
          <Typography marginBottom={2}>
            Select the CAB Quarter and effective date for retiring policy (or
            policies) across all health plans
          </Typography>
          <Stack direction="row" spacing={2}>
            {/* CAB Quarter Select */}
            <FormControl fullWidth margin="normal">
              <InputLabel id="cab-quarter-label">CAB Quarter</InputLabel>
              <Select
                labelId="cab-quarter-label"
                id="cab-quarter-select"
                value={cabQuarter}
                onChange={(e) => setCabQuarter(e.target.value)}
                label="CAB Quarter"
              >
                <MenuItem value={"Q1"}>Q1</MenuItem>
                <MenuItem value={"Q2"}>Q2</MenuItem>
                <MenuItem value={"Q3"}>Q3</MenuItem>
                <MenuItem value={"Q4"}>Q4</MenuItem>
              </Select>
            </FormControl>
            {/* CAB Year Select */}
            <FormControl fullWidth margin="normal">
              <InputLabel id="cab-year-label">CAB Year</InputLabel>
              <Select
                labelId="cab-year-label"
                id="cab-year-select"
                value={cabYear}
                onChange={(e) => setCabYear(e.target.value)}
                label="CAB Year"
              >
                <MenuItem value={"2023"}>2023</MenuItem>
                <MenuItem value={"2024"}>2024</MenuItem>
                <MenuItem value={"2025"}>2025</MenuItem>
                <MenuItem value={"2026"}>2026</MenuItem>
                <MenuItem value={"2027"}>2027</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          {/* Date Picker */}
          <Box marginTop={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="Effective Date"
                inputFormat="MM/DD/YYYY"
                slotProps={{ textField: { fullWidth: true, size: "small" } }}
                value={effectiveDate}
                onChange={handleDateChange}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      }
      actions={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            onClick={handleRetirePolicyConfirm}
            color="primary"
            disabled={isConfirmDisabled}
          >
            Ok
          </Button>
        </Box>
      }
    ></ContentModal>
  );
};

export default RetirePolicyDialog;
